module.exports = __webpack_public_path__ + "assets/img/libero.d254932b.png";